'use client';

import dynamic from 'next/dynamic';

function ProductInputToolSkeleton() {
  return (
    <div className="flex w-full flex-col items-center md:px-4" aria-busy="true" aria-label="input tool loading">
      <div className="h-[227px] w-full max-w-[57vw] animate-pulse rounded-2xl bg-white/5 sm:h-[560px] md:max-w-full" />
    </div>
  );
}

const ProductInputTool = dynamic(() => import('./impl'), {
  ssr: false,
  loading: () => <ProductInputToolSkeleton />,
});

export default ProductInputTool;
